import "../../layouts/AuthLayout.scss";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import ServerError from "../../assets/img/500.svg?react";
import { CDataTypography } from "../../components/text/CDataTypography";

interface Page500Props {
  hideReturnToWebsiteButton?: boolean;
  error?: Error | null;
}

const Page500 = (props: Page500Props) => {
  const { hideReturnToWebsiteButton, error } = props;
  return (
    <div className="text-center auth-message" style={{ marginTop: "40px" }}>
      <ServerError aria-description="Page not found" />
      <p className="h4 mt-4">Error 500</p>
      <p className="h1">Internal Server Error</p>
      <p className="font-weight-normal mt-3 mb-4">
        {!error && (
          <CDataTypography
            color={"typography-color-medium-grey"}
            variant={"typography-variant-body-regular"}
          >
            The server encountered an unexpected issue that prevented it from
            fulfilling your request. Please attempt your request again and if
            the issue persists, reach out to our support team at{" "}
            <a href="mailto:support@cdata.com">support@cdata.com</a> for further
            assistance.
          </CDataTypography>
        )}
        {error && <>{error.message}</>}
      </p>
      {!hideReturnToWebsiteButton && (
        <Link to="/">
          <Button color="primary" size="md">
            Return to Connect Cloud
            <i className="fa fa-arrow-right ms-2" />
          </Button>
        </Link>
      )}
    </div>
  );
};

export default Page500;
